import React from "react";
import "./Nav.scss";

export default function Nav() {
  return <></>;
}
